<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF PRODUCT</b></h5>
    <hr />
    <TableProductIndex
      :fields="fields.fields"
      :filter="this.filter"
      :page="this.page"
      :name="this.name"
    />
  </b-card>
</template>

<script>
import TableProductIndex from "@/table/admin/product/TableProductIndex";

export default {
  data() {
    return {
      items: [],

      // filter
      filter: "",
      page: "",
      name: "",

      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Product Name",
            key: "name",
            sortable: true
          },
          {
            label: "Product Size",
            key: "size",
            sortable: true
          },
          {
            label: "Product Type",
            key: "type",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      }
    };
  },

  created() {
    if (this.$route.query.filter !== undefined) {
      this.filter = this.$route.query.filter;
      this.page = this.$route.query.page;
      this.name = this.$route.query.name;
    }
  },

  methods: {
    getProduct() {
      let param = "";
      this.$store.dispatch("getProduct", param).then(res => {
        let no = 0;
        res.data.data.forEach(element => {
          no = no + 1;
          this.items.push({
            no: no,
            name: element.name,
            size: element.size,
            type: element.type,
            id: element.product_id
          });
        });
        this.totalRows = this.items.length;
      });
    }
  },
  components: {
    TableProductIndex
  }
};
</script>
<style lang="css" scoped></style>
